import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=1a056ac4"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a056ac4')) {
      api.createRecord('1a056ac4', component.options)
    } else {
      api.reload('1a056ac4', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=1a056ac4", function () {
      api.rerender('1a056ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/shortcodes/Slider.vue"
export default component.exports